const React = require('react');
const TimeFilterBtn = require('../TimeFilterBtn');
const noop = require("mn-utils/noop");

module.exports = ({value: timePeriodActive, onChange = noop}) => {
  const timePeriods = [
    {
      id: 'all',
      title: 'All Time'
    },
    {
      id: 'day',
      title: 'Today'
    },
    {
      id: 'month',
      title: 'Month'
    },
    {
      id: 'year',
      title: 'Year'
    },
  ];

  return (
    <div className="layoutRow (w1/4)>1">
      {timePeriods.map(({id, title}) => (
        <TimeFilterBtn
          key={id}
          id={id}
          active={timePeriodActive ? timePeriodActive === id : id === 'all'}
          onClick={(id) => onChange(id)}
        >
          {title}
        </TimeFilterBtn>
      ))}
    </div>
  );
};
